import { formatPhoneNumberIntl, isValidPhoneNumber } from 'react-phone-number-input';

const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export const getCurrencyFormatter = (): Intl.NumberFormat => {
  return currencyFormatter;
};

export const formatPhoneNumber = (phoneNumber: string): string => {
  if (isValidPhoneNumber(phoneNumber)) {
    return formatPhoneNumberIntl(phoneNumber);
  }

  if (isValidPhoneNumber(`+${phoneNumber}`)) {
    return formatPhoneNumberIntl(`+${phoneNumber}`);
  }

  return phoneNumber;
};
